<template>
  <a-modal
    :visible="visible"
    title="Inactivar usuario"
    width="736px"
    :destroy-on-close="true"
    :mask-closable="false"
    :footer="null"
    :keyboard="false"
    :body-style="bodyStyle"
    centered
    @cancel="handleCloseModalHeader"
  >
    <section class="flex">
      <div class="container__left">
        <div class="container__inactive">
          <img
            class="image__delete"
            src="@/app/users/assets/profiles/question-circle.png"
            alt="inactivar"
          />
          <p class="text__alert">¿Estás seguro de inactivar a</p>
          <p class="text__alert">“{{ record.first_name }} {{ record.last_name }}”?</p>
        </div>
        <div class="container__info">
          <p class="text">Sucederán las siguientes acciones:</p>
          <ul>
            <li>Se desactivará de estrategias, colas y campañas a las que esté asociado.</li>
            <li>
              Todos los tickets activos se reenviarán a su cola respectiva para que sean atendidos.
            </li>
            <li>
              Se quitara de la lista de usuarios y no se cobrará este usuario en la siguiente
              facturación.
            </li>
            <li>
              Al tener contactos asignados, estos deberán ser transferidos a otro(s) usuario(s)
              activos. Esta transferencia será de forma aleatoria.
            </li>
          </ul>
          <p>
            Te recordamos que actualmente {{ record.first_name }} {{ record.last_name }} cuenta con
            <span style="font-weight: 600">“{{ record.assigned_contacts }} contacto asignado ”</span
            >.
          </p>
        </div>
      </div>

      <div class="container__right">
        <p>Selecciona los agentes a los que deseas transferir los contactos de este usuario.</p>
        <AgentAssignedCheckList :record="record" :inactivateUser="true" />
      </div>
      <div class="footer">
        <div>
          <a-button class="footer__back" @click="handleCloseModalHeader"> Cancelar </a-button>
          <a-button
            class="footer__next"
            type="primary"
            @click="handleSaveUserAssigned"
            :disabled="isDisabled"
            :loading="loading"
          >
            Inactivar usuario
          </a-button>
        </div>
      </div>
    </section>
  </a-modal>
</template>

<script>
import { defineComponent } from "vue";
import { UserStatus } from "@/app/shared/utils/enums";
import AgentAssignedCheckList from "@/app/shared/components/sections/AgentAssignedCheckList.vue";

export default defineComponent({
  name: "InactiveAgentAssigned",
  components: {
    AgentAssignedCheckList,
  },
  props: {
    record: {
      type: Object,
      default: null,
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const bodyStyle = {
      height: "603px",
      loading: false,
    };

    return {
      bodyStyle,
    };
  },
  data() {
    return {
      UserStatus,
      cheked: [],
    };
  },
  computed: {
    getSelectedIdGroup() {
      return this.$store.getters["getIdSelectedContact"];
    },
  },
  methods: {
    async handleCloseModal() {
      await this.updateStatus();
      this.$emit("onCancel");
    },
    handleCloseModalHeader() {
      this.$emit("onCancel");
    },
    async updateStatus() {
      try {
        const body = {
          status: UserStatus.inactive,
        };
        await this.$store.dispatch("updateUser", {
          id: this.record.id,
          params: body,
        });
      } catch (error) {
        this.$message.error("El correo ya se encuentra registrado", 10);
      }
      this.$emit("onCloseModal");
    },
    async handleSaveUserAssigned() {
      try {
        const cheked = this.getSelectedIdGroup;
        const uniqueSelectedUsers = [...new Set(cheked)];

        this.loading = true;
        const data = {
          initial_user: this.record.id,
          final_users: uniqueSelectedUsers,
        };
        await this.$store.dispatch("agentAssignedContact", data);
        await this.handleCloseModal();
        this.$emit("update");
        this.$store.dispatch("cleanListAgents");
        this.$store.dispatch("fetchAllUsers");
        this.loading = false;
      } catch {
        this.loading = false;
        this.$message.error("error asignar un agente");
      }
    },
  },
});
</script>

<style lang="sass" scoped>
.image__delete
  margin-bottom: 10px
  margin-top: 10px

.text__alert
  font-size: 16px
  font-weight: 600
  margin: 0

.button__disabled
  margin-top: 10px

.footer__delete
  margin-bottom: 20px

.container__inactive
  text-align: center
  color: $gray-13

.container__info
  margin-bottom: 18px
  color: $gray-8

.text
  margin-top: 20px
  margin-bottom: 12px

.flex
  display: flex
  justify-content: space-around

.container__left
  width: 50%

.container__right
  width: 45%

.footer
  display: flex
  justify-content: flex-end
  position: absolute
  left: 0
  width: 100%
  height: 56px
  bottom: 0
  background: $white
  align-items: center
  border-top: 1px solid $gray-5
  border-radius: 0px 0px 4px 4px
  &__next
    margin-right: 1rem
  &__back
    margin-right: 1rem
</style>
